<template>
  <div class="modal" :class="{ 'modal-open': visible === true }">
    <div class="modal-box w-11/12 max-w-2xl">
      <h3 class="font-bold text-lg mb-4">{{ isEdit === true ? (t('mcpConnections.editTitle') || 'Edit Connection') : (t('mcpConnections.addTitle') || 'Add Connection') }}</h3>

      <div class="space-y-4">
        <div>
          <label class="label"><span class="label-text">{{ t('mcpConnections.fields.name') || 'Name' }}</span></label>
          <input type="text" v-model="localForm.name" class="input input-bordered w-full" placeholder="e.g. Team GitHub MCP" />
        </div>

        <div>
          <label class="label"><span class="label-text">{{ t('mcpConnections.fields.type') || 'Type' }}</span></label>
          <input type="text" disabled :value="type" class="input input-bordered w-full" />
        </div>

        <div>
          <label class="label"><span class="label-text">{{ t('mcpConnections.fields.endpoint') || 'Endpoint' }}</span></label>
          <input type="text" v-model="localForm.endpoint" class="input input-bordered w-full" placeholder="ws:// or http(s)://" />
        </div>

        <div v-if="type === 'filesystem'" class="grid grid-cols-1 md:grid-cols-2 grid-space-4">
          <div>
            <label class="label"><span class="label-text">Root Path</span></label>
            <input type="text" v-model="localForm.config.root" class="input input-bordered w-full" placeholder="/var/data" />
          </div>
          <div>
            <label class="label"><span class="label-text">Read Only</span></label>
            <select v-model="localForm.config.readOnly" class="select select-bordered w-full">
              <option :value="true">true</option>
              <option :value="false">false</option>
            </select>
          </div>
        </div>

        <div v-else-if="type === 'postgres'" class="grid grid-cols-1 md:grid-cols-2 grid-space-4">
          <div>
            <label class="label"><span class="label-text">Host</span></label>
            <input type="text" v-model="localForm.config.host" class="input input-bordered w-full" placeholder="localhost" />
          </div>
          <div>
            <label class="label"><span class="label-text">Port</span></label>
            <input type="number" v-model.number="localForm.config.port" class="input input-bordered w-full" placeholder="5432" />
          </div>
          <div>
            <label class="label"><span class="label-text">Database</span></label>
            <input type="text" v-model="localForm.config.database" class="input input-bordered w-full" />
          </div>
          <div>
            <label class="label"><span class="label-text">User</span></label>
            <input type="text" v-model="localForm.config.user" class="input input-bordered w-full" />
          </div>
          <div class="md:col-span-2">
            <label class="label"><span class="label-text">Password</span></label>
            <input type="password" v-model="localForm.config.password" class="input input-bordered w-full" />
          </div>
        </div>

        <div v-else-if="type === 'slack'" class="grid grid-cols-1 md:grid-cols-2 grid-space-4">
          <div>
            <label class="label"><span class="label-text">Bot Token</span></label>
            <input type="password" v-model="localForm.config.botToken" class="input input-bordered w-full" />
          </div>
          <div>
            <label class="label"><span class="label-text">Signing Secret</span></label>
            <input type="password" v-model="localForm.config.signingSecret" class="input input-bordered w-full" />
          </div>
        </div>

        <div v-else-if="type === 'github'" class="grid grid-cols-1 md:grid-cols-2 grid-space-4">
          <div>
            <label class="label"><span class="label-text">Access Token</span></label>
            <input type="password" v-model="localForm.config.token" class="input input-bordered w-full" />
          </div>
          <div>
            <label class="label"><span class="label-text">Organization/User</span></label>
            <input type="text" v-model="localForm.config.owner" class="input input-bordered w-full" placeholder="org or user" />
          </div>
        </div>

        <div v-else-if="type === 'weaviate' || type === 'qdrant' || type === 'elasticsearch'" class="grid grid-cols-1 md:grid-cols-2 grid-space-4">
          <div>
            <label class="label"><span class="label-text">API URL</span></label>
            <input type="text" v-model="localForm.config.url" class="input input-bordered w-full" placeholder="https://..." />
          </div>
          <div>
            <label class="label"><span class="label-text">API Key</span></label>
            <input type="password" v-model="localForm.config.apiKey" class="input input-bordered w-full" />
          </div>
        </div>

        <div v-else-if="type === 'openapi'" class="grid grid-cols-1 md:grid-cols-2 grid-space-4">
          <div class="md:col-span-2">
            <label class="label"><span class="label-text">Spec URL</span></label>
            <input type="text" v-model="localForm.config.specUrl" class="input input-bordered w-full" placeholder="https://.../openapi.json" />
          </div>
          <div>
            <label class="label"><span class="label-text">Auth Header</span></label>
            <input type="text" v-model="localForm.config.authHeader" class="input input-bordered w-full" placeholder="Authorization: Bearer ..." />
          </div>
        </div>

        <div v-else-if="type === 'web-search'" class="grid grid-cols-1 md:grid-cols-2 grid-space-4">
          <div>
            <label class="label"><span class="label-text">Provider</span></label>
            <input type="text" v-model="localForm.config.provider" class="input input-bordered w-full" placeholder="serper, tavily, bing" />
          </div>
          <div>
            <label class="label"><span class="label-text">API Key</span></label>
            <input type="password" v-model="localForm.config.apiKey" class="input input-bordered w-full" />
          </div>
        </div>

        <div v-else class="grid grid-cols-1 md:grid-cols-2 grid-space-4">
          <div class="md:col-span-2">
            <label class="label"><span class="label-text">Config (JSON)</span></label>
            <textarea v-model="jsonConfig" class="textarea textarea-bordered w-full" rows="6" />
          </div>
        </div>
      </div>

      <div class="modal-action">
        <button class="btn" @click="emitClose">{{ t('common.cancel') || 'Cancel' }}</button>
        <button class="btn" @click="emitSave">{{ t('common.save') || 'Save' }}</button>
      </div>
    </div>
    <form method="dialog" class="modal-backdrop"><button @click="emitClose">close</button></form>
  </div>
</template>

<script setup>
import { reactive, ref, watch, computed } from 'vue'
import { useI18n } from '@/i18n.js'

const { t } = useI18n()

const props = defineProps({
  visible: { type: Boolean, default: false },
  type: { type: String, default: '' },
  model: { type: Object, default: () => ({}) },
  isEdit: { type: Boolean, default: false }
})

const emit = defineEmits(['close', 'save'])

const localForm = reactive({
  name: '',
  endpoint: '',
  config: {}
})

const jsonConfig = ref('')

watch(() => props.model, (val) => {
  if (val !== undefined && val !== null) {
    localForm.name = typeof val.name === 'string' ? val.name : ''
    localForm.endpoint = typeof val.endpoint === 'string' ? val.endpoint : ''
    const cfg = typeof val.config === 'object' && val.config !== null ? val.config : {}
    localForm.config = { ...cfg }
    jsonConfig.value = JSON.stringify(localForm.config, null, 2)
  }
}, { immediate: true })

watch(() => props.type, () => {
  if (jsonConfig.value === '' || jsonConfig.value === '{}') {
    jsonConfig.value = JSON.stringify(localForm.config, null, 2)
  }
})

watch(jsonConfig, (val) => {
  try {
    const parsed = JSON.parse(val)
    if (parsed !== undefined && parsed !== null) {
      localForm.config = parsed
    }
  } catch (e) {
  }
})

function emitClose() {
  emit('close')
}

function emitSave() {
  emit('save', { name: localForm.name, endpoint: localForm.endpoint, config: localForm.config, type: props.type })
}
</script>

<style scoped>
</style>


